module.exports = __webpack_public_path__ + "static/media/graphMonitor.791f11b1.png";